import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = '',
  ...props
}: ButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`bg-depto-amber hover:bg-depto-amberDark text-white font-bold py-4 px-8 rounded-xl shadow-lg transition-colors duration-300 text-lg sm:text-xl w-full sm:w-auto ${className}`} {...props} data-id="element-28">
      {children}
    </motion.button>;
}